import React from 'react'
import { KnowledgeBasePathSettingsPopup } from '../modals'
import { useOpenModalDescriptor } from '../../store/modals'
import { FeedbotSuspense } from '../design-system/FeedbotSuspense'
import { UtteranceClassifierPopup } from './UtteranceClassifierPopup'

const StepSettingsPopup = React.lazy(() =>
  import('./StepSettingsPopup').then(module => ({ default: module.StepSettingsPopup }))
)
const ChannelsSettingsPopup = React.lazy(() =>
  import('./ChannelsSettingsPopup/ChannelsSettingPopup').then(module => ({
    default: module.ChannelsSettingsPopup
  }))
)
const NlpSettingsPopup = React.lazy(() =>
  import('./NlpSettingsPopup').then(module => ({ default: module.NlpSettingsPopup }))
)
const BotSettingsPopup = React.lazy(() =>
  import('./BotSettingsPopup').then(module => ({ default: module.BotSettingsPopup }))
)
const FeaturesPopup = React.lazy(() =>
  import('./FeaturesPopup').then(module => ({ default: module.FeaturesPopup }))
)
const IntentSettingsPopup = React.lazy(() =>
  import('./IntentSettingsPopup').then(module => ({ default: module.IntentSettingsPopup }))
)
const CreateBotSettingsPopup = React.lazy(() =>
  import('./CreateBotSettingsPopup').then(module => ({ default: module.CreateBotSettingsPopup }))
)
const NlpModelsTestPopup = React.lazy(() =>
  import('./NlpModelsTestPopup').then(module => ({ default: module.NlpModelsTestPopup }))
)
const FuzzyQuestionTestPopup = React.lazy(() =>
  import('./FuzzyQuestionTestPopup').then(module => ({ default: module.FuzzyQuestionTestPopup }))
)
const KnowledgeBaseUploadDocumentPopup = React.lazy(() =>
  import('./KnowledgeBaseUploadDocumentPopup').then(module => ({
    default: module.KnowledgeBaseUploadDocumentPopup
  }))
)
const KnowledgeBaseCreateDocumentPopup = React.lazy(() =>
  import('./KnowledgeBaseCreateDocumentPopup').then(module => ({
    default: module.KnowledgeBaseCreateDocumentPopup
  }))
)
const AddNlpModelSettingsPopup = React.lazy(() =>
  import('./AddNlpModelSettingsPopup').then(module => ({
    default: module.AddNlpModelSettingsPopup
  }))
)
const AddKnowledgeBaseSettingsPopup = React.lazy(() =>
  import('./AddKnowledgeBaseSettingsPopup').then(module => ({
    default: module.AddKnowledgeBaseSettingsPopup
  }))
)
const NlpModelSettingsPopup = React.lazy(() =>
  import('./NlpModelSettingsPopup').then(module => ({
    default: module.NlpModelSettingsPopup
  }))
)
const KnowledgeBaseSettingsPopup = React.lazy(() =>
  import('./KnowledgeBaseSettingsPopup').then(module => ({
    default: module.KnowledgeBaseSettingsPopup
  }))
)
const UnmatchedUtteranceSettingsPopup = React.lazy(() =>
  import('../modals').then(module => ({ default: module.UnmatchedUtteranceSettingsPopup }))
)

export const Modals: React.FC = () => {
  const descriptor = useOpenModalDescriptor()

  return (
    <FeedbotSuspense name="modals" fallback={<div></div>}>
      {descriptor?.type === 'step_settings' && <StepSettingsPopup modalDescriptor={descriptor} />}

      {descriptor?.type === 'channels_settings' && <ChannelsSettingsPopup />}

      {descriptor?.type === 'nlp_settings' && <NlpSettingsPopup />}

      {descriptor?.type === 'bot_settings' && <BotSettingsPopup />}

      {descriptor?.type === 'features_settings' && <FeaturesPopup />}

      {descriptor?.type === 'intent_settings' && (
        <IntentSettingsPopup modalDescriptor={descriptor} />
      )}

      {descriptor?.type === 'create_bot_settings' && (
        <CreateBotSettingsPopup modalDescriptor={descriptor} />
      )}

      {descriptor?.type === 'nlp_models_test' && (
        <NlpModelsTestPopup modalDescriptor={descriptor} />
      )}

      {descriptor?.type === 'utterance_classifier' && (
        <UtteranceClassifierPopup modalDescriptor={descriptor} />
      )}

      {descriptor?.type === 'fuzzy_question_nlp_test' && (
        <FuzzyQuestionTestPopup modalDescriptor={descriptor} />
      )}

      {descriptor?.type === 'knowledge_base_upload_document' && (
        <KnowledgeBaseUploadDocumentPopup modalDescriptor={descriptor} />
      )}

      {descriptor?.type === 'unmatched_utterance_settings' && (
        <UnmatchedUtteranceSettingsPopup modalDescriptor={descriptor} />
      )}

      {descriptor?.type === 'knowledge_base_path_settings' && (
        <KnowledgeBasePathSettingsPopup modalDescriptor={descriptor} />
      )}

      {descriptor?.type === 'add_nlp_model_settings' && (
        <AddNlpModelSettingsPopup modalDescriptor={descriptor} />
      )}

      {descriptor?.type === 'add_knowledge_base_settings' && (
        <AddKnowledgeBaseSettingsPopup modalDescriptor={descriptor} />
      )}

      {descriptor?.type === 'nlp_model_settings' && (
        <NlpModelSettingsPopup modalDescriptor={descriptor} />
      )}

      {descriptor?.type === 'knowledge_base_settings' && (
        <KnowledgeBaseSettingsPopup modalDescriptor={descriptor} />
      )}

      {descriptor?.type === 'knowledge_base_create_document' && (
        <KnowledgeBaseCreateDocumentPopup modalDescriptor={descriptor} />
      )}
    </FeedbotSuspense>
  )
}
